module.exports = __webpack_public_path__ + "img/4A_old.edcedd5d.jpg";